import {Badge} from '@common-web/components/ui/badge';
import {SCOPE_LABELS, type PermissionScope} from '@common/permissions';

export function ScopeBadge({scope}: {scope: PermissionScope}) {
  return (
    <Badge variant='outline' className='text-xs'>
      {SCOPE_LABELS[scope] ?? scope}
    </Badge>
  );
}
